import React from 'react'
import { getDocumentHead } from 'components/DocumentHead'
import ServiceFiltering from 'components/Organization/Features/ServiceFiltering'

export default function ServiceFilteringPage(): React.ReactElement {
  return <ServiceFiltering />
}

export const Head = getDocumentHead({
  title: 'Service Filtering DNS Solutions',
  description:
    'Control D’s service filtering platform allows you to control how services are accessed on your network. Signup and onboard in minutes.',
})
